import { logError } from './remoteLogger';

const lazyWithLogging =
  <T extends { default: React.ComponentType<any> }>(
    factory: () => Promise<T>,
    fallback?: React.ComponentType<any>
  ): (() => Promise<T>) =>
  () =>
    factory().catch((error: unknown) => {
      if (error instanceof Error) {
        logError('ChunkLoad', 'Failed to load chunk', error);
      }
      if (fallback) {
        return { default: fallback } as T;
      }
      throw error;
    });

export default lazyWithLogging;
